import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import supabase from '../config/supabaseClient';
import { Link } from 'react-router-dom';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      // Test Supabase connection first
      const { error: connectionError } = await supabase.auth.getSession();
      
      if (connectionError) {
        console.error('Supabase connection error:', connectionError);
        throw new Error('Connection to authentication service failed');
      }

      // Proceed with password reset
      const resetUrl = window.location.origin + '/update-password';
      const { error } = await resetPassword(email, {
        redirectTo: resetUrl
      });
      
      if (error) {
        console.error('Reset password error:', error);
        throw error;
      }

      setMessage('If an account exists with this email, you will receive a password reset link shortly. Please also check your spam folder.');
      
    } catch (error) {
      console.error('Reset password error:', error);
      setError('Error sending reset link: ' + (error.message || 'Please try again'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '400px',
        width: '100%',
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img 
            src="/logo.png" 
            alt="Pre Go Prep" 
            style={{ 
              height: '60px',
              marginBottom: '20px'
            }}
          />
          <h2 style={{ 
            color: '#29458d',
            fontSize: '24px',
            marginBottom: '10px'
          }}>Reset Password</h2>
          <p style={{ 
            color: '#666',
            fontSize: '14px',
            marginBottom: '20px'
          }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        {message && (
          <div style={{ 
            backgroundColor: '#d4edda', 
            color: '#155724',
            padding: '15px',
            borderRadius: '4px',
            marginBottom: '20px'
          }}>
            {message}
          </div>
        )}
        
        {error && (
          <div style={{ 
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '15px',
            borderRadius: '4px',
            marginBottom: '20px'
          }}>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '4px',
                border: '1px solid #ced4da',
                fontSize: '16px',
                transition: 'border-color 0.2s',
                '&:focus': {
                  borderColor: '#29458d',
                  outline: 'none'
                }
              }}
            />
          </div>
          
          <button 
            type="submit" 
            disabled={isLoading} 
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#29458d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.7 : 1,
              transition: 'background-color 0.2s',
              '&:hover': {
                backgroundColor: '#1e3266'
              }
            }}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>

          <div style={{ 
            marginTop: '20px',
            textAlign: 'center'
          }}>
            <Link 
              to="/login" 
              style={{
                color: '#29458d',
                textDecoration: 'none',
                fontSize: '14px',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Back to Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;